import Renderer from "@wielink/datatables/Renderers/Renderer";

class ActionRenderer extends Renderer {
	render() {
		let editUrl = this.config.editUrl;
		for(let key in this.row) {
			editUrl = editUrl.replace(`_${key}_`, this.row[key]);
		}

		return `
			<div class="d-inline-flex gap-2">
				<a href="${editUrl}" data-dt-btn="edit" class="btn btn-sm btn-success" aria-label="Bewerken" title="Bewerken">
					<i class="bi bi-pencil-square"></i>
				</a>
				<button data-dt-btn="delete" data-id="${this.row.id}" class="btn btn-sm btn-danger" aria-label="Verwijderen" title="Verwijderen">
					<i class="bi bi-trash3-fill"></i>
				</button>
			</div>
		`
	}
}

export default ActionRenderer;